import { render, staticRenderFns } from "./DepartmentTestimonial.vue?vue&type=template&id=a8ac5876"
import script from "./DepartmentTestimonial.vue?vue&type=script&lang=js"
export * from "./DepartmentTestimonial.vue?vue&type=script&lang=js"
import style0 from "./DepartmentTestimonial.vue?vue&type=style&index=0&id=a8ac5876&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports